import { Link } from "react-router-dom";
import { Phone, MessageSquare, MapPin, Mail, ExternalLink } from "lucide-react";
import logo from "@/assets/logo.webp";

const Footer = () => {
  return (
    <footer className="bg-primary text-primary-foreground">
      <div className="container mx-auto px-4 py-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {/* Brand */}
          <div>
            <Link to="/" className="inline-block mb-4">
              <img 
                src={logo} 
                alt="Big Bear's Pro Floors" 
                className="h-20 w-auto"
                width={80}
                height={80}
                loading="lazy"
              />
            </Link>
            <p className="text-primary-foreground/80 text-sm leading-relaxed">
              Professional hardwood, LVP, and stair installation serving Colorado Springs and surrounding areas.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="font-heading font-bold text-lg mb-4 uppercase tracking-wide">Quick Links</h3>
            <nav className="flex flex-col gap-2">
              <Link to="/gallery" className="text-primary-foreground/80 hover:text-accent transition-colors">Gallery</Link>
              <Link to="/reviews" className="text-primary-foreground/80 hover:text-accent transition-colors">Reviews</Link>
              <Link to="/about" className="text-primary-foreground/80 hover:text-accent transition-colors">About</Link>
              <Link to="/contact" className="text-primary-foreground/80 hover:text-accent transition-colors">Contact</Link>
            </nav>
          </div>

          {/* Contact */}
          <div>
            <h3 className="font-heading font-bold text-lg mb-4 uppercase tracking-wide">Contact</h3>
            <div className="flex flex-col gap-3">
              <a href="tel:+17192327424" className="flex items-center gap-3 text-primary-foreground/80 hover:text-accent transition-colors">
                <Phone size={18} />
                <span>(719) 232-7424</span>
              </a>
              <a href="sms:+17192327424" className="flex items-center gap-3 text-primary-foreground/80 hover:text-accent transition-colors">
                <MessageSquare size={18} />
                <span>Text Us</span>
              </a>
              <a href="mailto:bigbearsfloors@gmail.com" className="flex items-center gap-3 text-primary-foreground/80 hover:text-accent transition-colors">
                <Mail size={18} />
                <span>bigbearsfloors@gmail.com</span>
              </a>
              <div className="flex items-start gap-3 text-primary-foreground/80">
                <MapPin size={18} className="mt-1 flex-shrink-0" />
                <span>Colorado Springs & Surrounding Areas</span>
              </div>
            </div>
          </div>
        </div>

        <div className="border-t border-primary-foreground/20 mt-8 pt-8 text-center">
          <p className="text-primary-foreground/60 text-sm">
            © {new Date().getFullYear()} Big Bear's Pro Floors. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
